<template>
  <div>
    <h1>{{ $t("settings.externalCompany.externalCompaniesList") }}</h1>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="externalCompanies"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      :search="search"
      class="elevation-1"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ props.item.name }}
          </td>
          <td class="text-left">
            <span v-if="props.item.is_enabled === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_enabled === 0">{{ $t("global.no") }}</span>
          </td>
          <td class=" justify-center align-content-center px-0">
            <span v-if="props.item.used_in_delegations > 0"
              >{{ $t("settings.externalCompany.assignedNDelegations", props.item.used_in_delegations, { count: props.item.used_in_delegations }) }} <br
            /></span>
            <span v-if="props.item.used_in_delegations === 0">{{ $t("settings.externalCompany.noAssignedDelegations") }}<br /></span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import ExternalCompanyForm from "../../components/Settings/ExternalCompanyForm";

export default {
  name: "SettingsExternalCompanyView",
  // components: { ExternalCompanyForm },
  data: () => ({
    externalCompanies: [],
    search: ""
  }),
  created() {
    this.load();
  },
  computed: {
    headers() {
      return [
        { text: this.$t("delegationTask.headers.name"), value: "name" },
        {
          text: this.$t("delegationTask.headers.isEnabled"),
          value: "is_enabled"
        },
        { text: " ", value: "", sortable: false }
      ];
    },
    hasPermissionForEdit() {
      return this.$store.getters.hasPermission("SuperAdmin") || this.$store.getters.hasPermission("companyAdmin");
    }
  },
  methods: {
    load() {
      this.axios.get("settings/external-company/list").then(response => {
        this.externalCompanies = response.data;
      });
    }
  }
};
</script>

<style scoped></style>
